import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://www.echt.gold';

const Impressum = () => {
  return (
    <>
      <Helmet>
        <title>Impressum - Echt Gold</title>
        <meta name="description" content="Impressum und rechtliche Informationen von Echt Gold - Uhren-, Schmuck- und Gold- und Silberankauf in NRW." />
        <link rel="canonical" href={`${BASE_URL}/impressum`} />
      </Helmet>

      <div className="bg-black/90 py-8 border-b border-gold/20">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-400 mb-2">
            <Link to="/" className="hover:text-gold">Home</Link> / <span className="text-gold">Impressum</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold gold-text">Impressum</h1>
        </div>
      </div>

      <section className="section section-dark">
        <div className="container">
          <div className="max-w-4xl mx-auto prose prose-invert prose-gold">
            <div className="card">
              <h2 className="text-2xl font-bold mb-4 gold-text">Angaben gemäß § 5 TMG</h2>
              <p className="text-gray-300">
                Echt Gold<br />
                Neben dem Brand 10<br />
                44135 Dortmund<br />
                Deutschland
              </p>

              <h3 className="text-xl font-bold mt-6 mb-3 gold-text">Kontakt</h3>
              <p className="text-gray-300">
                Telefon: 0231 39085116<br />
                E-Mail: Info@echtgold.de
              </p>

              <h3 className="text-xl font-bold mt-6 mb-3 gold-text">Umsatzsteuer-ID</h3>
              <p className="text-gray-300">
                Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:<br />
                DE123456789 (Beispiel - bitte durch echte USt-ID ersetzen)
              </p>

              <h3 className="text-xl font-bold mt-6 mb-3 gold-text">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h3>
              <p className="text-gray-300">
                Echt Gold<br />
                Neben dem Brand 10<br />
                44135 Dortmund
              </p>

              <h3 className="text-xl font-bold mt-6 mb-3 gold-text">EU-Streitschlichtung</h3>
              <p className="text-gray-300">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">
                  https://ec.europa.eu/consumers/odr
                </a><br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>

              <h3 className="text-xl font-bold mt-6 mb-3 gold-text">Verbraucherstreitbeilegung</h3>
              <p className="text-gray-300">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>

              <h3 className="text-xl font-bold mt-6 mb-3 gold-text">Haftung für Inhalte</h3>
              <p className="text-gray-300 text-sm">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Impressum;